import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { formatPrice, rentLabel } from "@/lib/api";

const CATEGORY_LABEL = {
  transitorio: "Contratto transitorio",
  residenziale: "Medio-lungo termine",
  studenti: "Studenti e professionisti",
};

export default function PropertyCard({ property, className = "", wide = false }) {
  const p = property;
  const isSale = p.status === "vendita";
  return (
    <Link
      to={`/immobile/${p.code}`}
      data-testid="property-card-item"
      className={`group block ${className}`}
    >
      <div className={`relative overflow-hidden bg-sand3 ${wide ? "aspect-[16/10]" : "aspect-[4/3]"}`}>
        <img
          src={p.images?.[0]}
          alt={p.title}
          loading="lazy"
          className="tone-img h-full w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.06]"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-ink/25 via-transparent to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
        <span className="absolute left-5 top-5 bg-sand/95 px-3.5 py-1.5 text-[10px] font-medium uppercase tracking-wide2 text-ink backdrop-blur">
          {isSale ? "In vendita" : CATEGORY_LABEL[p.category] || "In locazione"}
        </span>
        <span className="absolute bottom-5 right-5 flex h-11 w-11 translate-y-3 items-center justify-center rounded-full bg-sand text-ink opacity-0 transition-all duration-500 group-hover:translate-y-0 group-hover:opacity-100">
          <ArrowUpRight className="h-5 w-5" />
        </span>
      </div>

      <div className="flex items-start justify-between gap-6 pt-5">
        <div>
          <h3 className="font-serif text-[22px] font-medium leading-snug text-ink transition-colors duration-300 group-hover:text-champagne">
            {p.title}
          </h3>
          {(p.zone || p.city) && (
            <p className="mt-1 text-[13px] font-light text-mut">
              {p.zone} · {p.city}
            </p>
          )}
        </div>
        {isSale && (
          <p className="whitespace-nowrap font-mono text-[13px] font-medium text-ink">
            {formatPrice(p)}
          </p>
        )}
      </div>

      <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-1 border-t border-ink/10 pt-3.5 font-mono text-[11px] text-mut">
        <span>{p.surface} m²</span>
        <span className="text-ink/20">/</span>
        <span>{p.rooms} vani</span>
        <span className="text-ink/20">/</span>
        <span>{p.bathrooms} {p.bathrooms > 1 ? "bagni" : "bagno"}</span>
        <span className="text-ink/20">/</span>
        <span>Piano {p.floor}</span>
      </div>
    </Link>
  );
}
